import React, { useState } from "react";
import { FaTimes } from "react-icons/fa";
import brandIcon from "assets/images/logo.png";
import { postRequest } from "../../../../../services/api/apiService";
import { toast } from "react-toastify";

const ConnectedPlatformTaboolaConnectModal = ({ isOpen, onClose, handleFetchConnectedPlatforms }) => {
  const [clientId, setClientId] = useState("");
  const [clientSecret, setClientSecret] = useState("");
  const [accountId, setAccountId] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  if (!isOpen) return null;

  const handleSave = async () => {
    if (!clientId || !clientSecret || !accountId) {
      setError("All fields are required.");
      return;
    }
    try {
      setLoading(true);
      setError(null);
      await postRequest("/api/ads-auth/taboola/connect", { clientId, clientSecret, accountId });
      toast.success("Taboola connected successfully!");
      onClose();
      handleFetchConnectedPlatforms();
    } catch (err) {
      const msg = err?.response?.data?.message || err?.message || "Connection failed.";
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-gray-900 bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white w-full max-w-md rounded-lg shadow-lg p-6 relative">
        <button className="absolute top-4 right-4 text-gray-600 hover:text-gray-800" onClick={onClose}>
          <FaTimes size={20} />
        </button>

        <div className="flex items-center gap-2 mb-4">
          <img src={brandIcon} alt="OneBotAds" style={{ height: "20px" }} />
        </div>

        <h2 className="text-lg font-bold text-gray-800 mb-1">Connect Taboola Ads</h2>
        <p className="text-sm text-gray-600 mb-4">
          Enter your Taboola API credentials. Find them in Taboola Backstage under{" "}
          <strong>Account Settings → API Access</strong>.
        </p>

        <div className="space-y-4 mb-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Client ID</label>
            <input
              type="text"
              className="mt-1 p-2 w-full border rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
              value={clientId}
              onChange={(e) => setClientId(e.target.value)}
              placeholder="e.g. 21432e380ba447bf..."
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Client Secret</label>
            <input
              type="password"
              className="mt-1 p-2 w-full border rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
              value={clientSecret}
              onChange={(e) => setClientSecret(e.target.value)}
              placeholder="Enter your Client Secret"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Account ID</label>
            <input
              type="text"
              className="mt-1 p-2 w-full border rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
              value={accountId}
              onChange={(e) => setAccountId(e.target.value)}
              placeholder="e.g. taboolaaccount-yourname"
            />
          </div>
        </div>

        <p className="text-xs text-gray-500 italic mb-4">
          Your credentials are encrypted and stored securely. We never share them.
        </p>

        {error && <div className="text-red-500 text-sm mb-4">{error}</div>}

        <div className="flex justify-end gap-4">
          <button onClick={onClose} className="px-4 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300">
            Cancel
          </button>
          <button
            onClick={handleSave}
            disabled={loading}
            className="px-4 py-2 bg-[#221C51] text-white rounded-lg hover:bg-[#1a1641] disabled:bg-gray-400"
          >
            {loading ? "Connecting..." : "Connect"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConnectedPlatformTaboolaConnectModal;
